import { useState, useEffect } from "react";
import { getCountdownConfig } from "containers/Events/Countdown";
import { dynamicCountdown } from "helpers/dynamicCountdown";

export const useUpcomingInternalEvent = ({ type, startAt, endAt, rsvpDeadlineDate }) => {
  const isInternalEvent = type === 'Event::Internal';
  
  const [countdownValue, setCountdownValue] = useState(() => 
    dynamicCountdown(startAt, endAt, rsvpDeadlineDate)
  );

  useEffect(() => {
    if (!isInternalEvent || countdownValue?.status === 'happening_now') return;

    const interval = setInterval(() => {
      const newValue = dynamicCountdown(startAt, endAt, rsvpDeadlineDate);
      
      setCountdownValue((prev) => {
        if (
          prev?.status !== newValue?.status ||
          prev?.days !== newValue?.days ||
          prev?.hours !== newValue?.hours ||
          prev?.minutes !== newValue?.minutes
        ) {
          return newValue;
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isInternalEvent, startAt, endAt, rsvpDeadlineDate, countdownValue?.status]);

  const config = getCountdownConfig(countdownValue);

  return { isInternalEvent, countdownValue, config };
};